export default __webpack_public_path__ + "static/media/rotor-solution-top.acdbde99.svg";